export default __webpack_public_path__ + "static/media/info.a2482adb.svg";